// extracted by mini-css-extract-plugin
export default {"button":"ws-button_button__3st2n"};